import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import _ from 'lodash';
import { validateEmail } from '../../helpers/commonFormFieldValidators';

const messages = defineMessages({
  required: { id: 'General.Required', defaultMessage: 'Required' },
  wrongFormat: { id: 'General.WrongFormat', defaultMessage: 'Wrong format' },
});

export default (values, props) => {
  const errors = { signerEmails: [] };

  if (!props.isMultipleSigners) {
    if (!values.signerEmail || !values.signerEmail.trim()) {
      errors.signerEmail = <FormattedMessage {...messages.required} />;
    }

    if (values.signerEmail && !validateEmail(values.signerEmail)) {
      errors.signerEmail = <FormattedMessage {...messages.wrongFormat} />;
    }
  } else {
    _.each(_.get(values, 'signerEmails', []), (signerEmail, index) => {
      if (!signerEmail || !signerEmail.trim()) {
        errors.signerEmails[index] = (
          <FormattedMessage {...messages.required} />
        );
      }

      if (signerEmail && !validateEmail(signerEmail)) {
        errors.signerEmails[index] = (
          <FormattedMessage {...messages.wrongFormat} />
        );
      }
    });
  }

  return errors;
};
